import { request } from '../core';
import { PageType } from '@/utils/enum';

class DeviceInfoApi {
  fetchDomain = `${location.protocol}//${process.env.JDX_APP_CLOUD_FETCH_DOMAIN}`;
  // 分页查询
  fetchTableList({
    pageNum,
    pageSize,
    searchForm,
  }: {
    pageNum: number;
    pageSize: number;
    searchForm: Object;
  }) {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/device/device_get_page_list',
      body: { ...searchForm, pageNum, pageSize },
    };
    return request(options);
  }
  //  新增编辑
  submitInfo({
    type,
    requestBody,
  }: {
    type: PageType.EDIT | PageType.ADD;
    requestBody: Object;
  }) {
    const options: RequestOptions = {
      method: 'POST',
      path:
        type === PageType.EDIT
          ? '/k2/management/device/device_edit'
          : '/k2/management/device/device_add',
      body: requestBody,
    };
    return request(options);
  }
  // 获取详情
  fetchDetail(id: number | string) {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/device/device_get_detail',
      body: { id },
    };
    return request(options);
  }
  // 获取api key
  getApiKey(deviceId: number) {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/device/device_get_api_key',
      body: {
        deviceId,
      },
    };
    return request(options);
  }

  // 搜索站点列表
  getStation(params: object) {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/station_base/get_station_address_list',
      body: { ...params },
    };
    return request(options);
  }

  //   获取设备硬件模板信息
  getDeviceTemplate({
    type,
    productType,
  }: {
    type: 'device_type' | 'device';
    productType: 'vehicle' | 'robot';
  }) {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/device_template/get_device_template_info',
      body: {
        type,
        productType,
      },
    };
    return request(options);
  }

  // 车型名称后的详情按钮展示信息
  getDeviceTypeInfo(deviceTypeBaseId: number) {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/device_type/get_device_type_info',
      body: {
        deviceTypeBaseId,
      },
    };
    return request(options);
  }

  // 批量上传车辆信息
  uploadDeviceInfo(deviceTypeBaseId: number) {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/upload/device_batch_add',
      body: {
        deviceTypeBaseId,
      },
    };
    return request(options);
  }

  // 车型名称后的详情按钮展示信息
  getUploadedInfo({
    pageNum,
    pageSize,
    searchForm,
  }: {
    pageNum: number;
    pageSize: number;
    searchForm: Object;
  }) {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/upload/device_batch_add_log',
      body: { ...searchForm, pageNum, pageSize },
    };
    return request(options);
  }

  unbindAndroidDeviceService(deviceName: string) {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/device/device_unbind_android_device',
      body: {
        deviceName,
      },
    };
    return request(options);
  }

  queryDeviceTypeList(params: {
    supplier?: string;
    productType?: string;
    enable?: 1 | 0;
  }) {
    const headers = {
      'LOP-DN': process.env.JDX_APP_REQUEST_HEADER!,
    };
    const options: RequestOptions = {
      method: 'POST',
      absoluteURL: `${this.fetchDomain}/k2/management/device_type/query_device_type_list`,
      headers,
      body: params,
    };
    return request(options);
  }

  /**
   * 批量导入车辆路权信息
   * @param {({
   *     serialNos: string;
   *     selfCountyId: number | null;
   *     startDate: string;
   *     endDate: string;
   *     fileInfo: { fileKey: string; bucketName: string; type?: string };
   *   })} params
   * @return {*}
   * @memberof DeviceInfoApi
   */
  batchAddVehicleRightOfWayInfo(params: {
    serialNos: string | null;
    provinceId: number | null;
    cityId: number | null;
    selfCountyId: number | null;
    startDate: string | null;
    endDate: string | null;
    fileInfo: { fileKey: string; bucketName: string; type?: string };
  }) {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/device/batch_add_vehicle_right_of_way_info',
      body: params,
    };
    return request(options);
  }

  /**
   * 获取车辆合格证信息
   * @param {{ vehicleName: string }} params
   * @returns Mock Promise<{code:'0000', data:{...}}>
   */
  getVehicleCertificateInfo(params: { vehicleName: string }) {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/device/get_vehicle_certificate_info',
      body: params,
    };
    return request(options);
  }

  /**
   * 编辑车辆合格证信息
   * @param params 参数对象
   * @returns Mock Promise<{code:'0000', data:{}}>
   */
  editVehicleCertificateInfo(params: {
    vehicleName: string;
    certificateNumber: string | null;
    producedDate: string | null;
    size: string | null;
    fileInfo: { fileKey: string; bucketName: string; type?: string } | null;
  }) {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/device/edit_vehicle_certificate_info',
      body: params,
    };
    return request(options);
  }

  /**
   * 查询车辆路权信息列表
   * @param {{ serialNo: string }} params
   * @returns Mock Promise<{code:'0000', data:{ list: [...] }}>
   */
  getVehicleRightOfWayInfo(params: { serialNo: string }) {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/device/get_vehicle_right_of_way_info',
      body: params,
    };
    return request(options);
  }

  /**
   * 编辑车辆路权信息
   * @param params { serialNo: string; vehicleRightOfWayInfoVOList: Array<{ selfCountyId:number; startDate:string; endDate:string; fileInfo:{ fileKey:string; bucketName:string; type?:string } }> }
   * @returns Mock Promise<{code:'0000', data:{}}>
   */
  editVehicleRightOfWayInfo(params: {
    serialNo: string;
    vehicleRightOfWayInfoVOList: Array<{
      provinceId: number | null;
      cityId: number | null;
      selfCountyId: number | null;
      startDate: string | null;
      endDate: string | null;
      fileInfo: { fileKey: string | null; bucketName: string; type?: string };
    }>;
  }) {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/device/edit_vehicle_right_of_way_info',
      body: params,
    };
    return request(options);
  }
}

const deviceInfoApi = new DeviceInfoApi();
export { deviceInfoApi, DeviceInfoApi };
